import type { HiringLink, HiringRequest } from '../../services/api';
import { DASH_STATUS_DOT, DASH_STATUS_WORDS, STORE_COLUMN_WORDS, storeHiringStatus, storeHiringWhy } from './hiringText.dashboard';

/**
 * What goes INSIDE a store's cell of the Stores page's small Hiring column (approved
 * mock-up of 15 Oct 2026, decision 2), and since 16 Oct 2026 of the same column on
 * Dashboard › Deployment › Undeployed Stores: one dot and one word, the Hiring dashboard's
 * four statuses - the most pressing of the store's live openings, or Being raised while a
 * hiring request for it waits. A dash when nothing is followed or waiting. The word opens
 * the store's hiring (HiringPanel); the reason a store needs attention is on hover.
 *
 * The table cell itself is written in the table, beside its header, so the two can never
 * fall out of step (the table Actions check counts the cells written in each row).
 */
export function StoreHiringDot({
  storeName, links, request = null, onOpen,
}: { storeName: string; links: readonly HiringLink[]; request?: HiringRequest | null; onOpen: () => void }) {
  const status = storeHiringStatus(links, request);
  if (!status) return <span className="text-xs text-gray-400">–</span>;
  const hover = storeHiringWhy(links, request, status);
  return (
    <button
      type="button"
      onClick={onOpen}
      aria-label={STORE_COLUMN_WORDS.openFor(storeName, status)}
      title={hover ?? undefined}
      className="inline-flex items-center gap-2 rounded text-left text-sm text-gray-800 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500"
    >
      <span aria-hidden="true" className={`inline-block h-2 w-2 shrink-0 rounded-full ${DASH_STATUS_DOT[status]}`} />
      {DASH_STATUS_WORDS[status]}
    </button>
  );
}

export default StoreHiringDot;
